const MINUTE_MS = 60 * 1000;

export const PULSE_QUERY_CACHE_POLICIES = {
  definitions: {
    staleTimeMs: 5 * MINUTE_MS,
    cacheTimeMs: 15 * MINUTE_MS,
  },
  details: {
    staleTimeMs: MINUTE_MS,
    cacheTimeMs: 5 * MINUTE_MS,
  },
  health: {
    staleTimeMs: 30 * 1000,
    cacheTimeMs: 2 * MINUTE_MS,
  },
  history: {
    staleTimeMs: 5 * MINUTE_MS,
    cacheTimeMs: 15 * MINUTE_MS,
  },
} as const;
